module.exports = __webpack_public_path__ + "media/שרשרת.1d39bc78.mp3";